import React from 'react';
import { Link } from 'react-router-dom';
import PetCard from './PetCard';

const Pets = ({ pets }) => {
    return pets.map((pet, index) => (
      <Link key={index} to={"/mascota/" + pet.id}>
        <div className="pet-card-size rounded-xl overflow-hidden shadow-2xl 
         transition-transform transform hover:scale-[102%]" >
          <PetCard data={pet} qr={true} buscador={true}/>
        </div>
        
      </Link>
    ));
};
  
export default Pets;